// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Link, useLocation, useParams } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// function ListBrand(props) {
//   const params = useParams();
//   const location = useLocation();
//   // const [table, setTable] = useState({
//   const [table, setTable] = useState({
//     head: ["Group", "Brand", "No. of Outlets", "Actions"],
//     data: false,
//   });

//   useEffect(() => {
//     const fetchData = async () => {
//       if (props.user && props.user.data) {
//         try {
//           const response = await axios.get(
//             props.chimeraserv.urlGet + "/group",
//             {
//               headers: {
//                 Authorization: props.user.data.usrKey,
//                 "Content-Type": "application/json",
//                 Accept: "application/json",
//               },
//             }
//           );
//           let data = [];
//           if (Object.keys(response.data).length) {
//             data = response.data;
//           }
//           setTable((prev) => ({
//             ...prev,
//             data: data,
//           }));
//         } catch (error) {
//           setTable((prev) => ({
//             ...prev,
//             data: [],
//           }));
//         }
//       }
//     };
//     fetchData();
//     // eslint-disable-next-line
//   }, [props.user, props.chimeraserv.urlGet]);

//   const valueChange = async (group, brand) => {
//     let groupIndex = group.brands
//       .map((brands, index) => ({ ...brands, index: index }))
//       .find((brands) => brands.braKey === brand.braKey);

//     const newStatus = group.brands[groupIndex.index].status === 1 ? 0 : 1;
//     group.brands[groupIndex.index].status = newStatus;

//     let dataToUpdate = {
//       ...group,
//     };

//     try {
//       await axios.put(
//         props.chimeraserv.urlPost + "/group/update",
//         dataToUpdate,
//         {
//           headers: {
//             Authorization: props.user.data.usrKey,
//             "Content-Type": "application/json",
//             Accept: "application/json",
//           },
//         }
//       );
//       // Update the local state to reflect the change
//       setTable((prev) => ({
//         ...prev,
//         data: prev.data.map((item) =>
//           item._id === group._id
//             ? {
//                 ...item,
//                 brands: item.brands.map((b) =>
//                   b.braKey === brand.braKey ? { ...b, status: newStatus } : b
//                 ),
//               }
//             : item
//         ),
//       }));
//     } catch (error) {
//       console.error("Error updating brand status:", error);
//     }
//   };

//   const renderData = () =>
//     table.data &&
//     table.data.map((data) =>
//       data.brands.map((brand, key) => (
//         <tr key={key}>
//           <td>{data.name}</td>
//           <td>{brand.name}</td>
//           <td>{brand.chains.length}</td>
//           <td className="actions">
//             {props.user.data.level === 0 ? (
//               <div className="actions actionsAdmin">
//                 <label className="switch">
//                   <input
//                     type="checkbox"
//                     id={brand.braKey}
//                     checked={!brand.status}
//                     onChange={() => valueChange(data, brand, key)}
//                   />
//                   <span className="slider"></span>
//                 </label>

//                 <Link
//                   to={
//                     location.pathname.split("/").splice(0, 4).join("/") +
//                     "/edit/" +
//                     brand.braKey
//                   }
//                 >
//                   <FontAwesomeIcon className="icon" icon={["fas", "cog"]} />{" "}
//                   Edit
//                 </Link>
//               </div>
//             ) : (
//               <div />
//             )}
//             <Link
//               to={
//                 location.pathname.split("/").splice(0, 4).join("/") +
//                 "/view/" +
//                 brand.braKey
//               }
//             >
//               <FontAwesomeIcon className="icon" icon={["fas", "eye"]} /> View
//             </Link>
//           </td>
//         </tr>
//       ))
//     );

//   const Loader =
//     props.components && props.components.setting && props.components.setting[1]
//       ? props.components.setting[1].component
//       : () => <div>Loading...</div>;

//   return (
//     <div className="custForm">
//       <div className="viewTitle">List of Brands</div>
//       <div>
//         {!table.data ? (
//           <Loader />
//         ) : (
//           <table className="table table-striped defaultTable">
//             <thead>
//               {/* <tr> */}
//               {table.head.map((head, key) => (
//                 <th scope="col" key={key}>
//                   {head}
//                 </th>
//               ))}
//               {/* </tr> */}
//             </thead>
//             <tbody>{renderData()}</tbody>
//           </table>
//         )}
//       </div>
//     </div>
//   );
// }
// export default ListBrand;
import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { Link, useLocation, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function ListBrand(props) {
  const params = useParams();
  const location = useLocation();
  const [table, setTable] = useState({
    head: ["Group", "Brand", "No. of Outlets", "Status", "Actions"],
    data: false,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [filterGroup, setFilterGroup] = useState("all");
  const [sortBy, setSortBy] = useState("brand");
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    const fetchData = async () => {
      if (props.user && props.user.data) {
        try {
          const response = await axios.get(
            props.chimeraserv.urlGet + "/group",
            {
              headers: {
                Authorization: props.user.data.usrKey,
                "Content-Type": "application/json",
                Accept: "application/json",
              },
            }
          );
          let data = [];
          if (Object.keys(response.data).length) {
            data = response.data;
          }
          setTable((prev) => ({
            ...prev,
            data: data,
          }));
        } catch (error) {
          setTable((prev) => ({
            ...prev,
            data: [],
          }));
        }
      }
    };
    fetchData();
  }, [props.user, props.chimeraserv.urlGet]);

  // Create flat brand data for filtering and searching
  const flatBrandData = useMemo(() => {
    if (!table.data) return [];

    const brands = [];
    table.data.forEach((group) => {
      group.brands.forEach((brand) => {
        brands.push({
          ...brand,
          groupName: group.name,
          groupId: group._id,
          groupKey: group.grpKey,
          group: group, // Keep reference to parent group
        });
      });
    });
    return brands;
  }, [table.data]);

  // Filter, search, and sort logic
  const filteredAndSortedData = useMemo(() => {
    if (!flatBrandData.length) return [];

    let filtered = flatBrandData.filter((brand) => {
      // Search filter
      const matchesSearch =
        searchTerm === "" ||
        brand.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        brand.groupName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        brand.braKey.toLowerCase().includes(searchTerm.toLowerCase());

      // Status filter
      const matchesStatus =
        filterStatus === "all" ||
        (filterStatus === "active" && brand.status === 1) ||
        (filterStatus === "inactive" && brand.status === 0);

      // Group filter
      const matchesGroup =
        filterGroup === "all" || brand.groupId === filterGroup;

      return matchesSearch && matchesStatus && matchesGroup;
    });

    // Sort data
    filtered.sort((a, b) => {
      let aValue, bValue;

      switch (sortBy) {
        case "brand":
          aValue = a.name.toLowerCase();
          bValue = b.name.toLowerCase();
          break;
        case "group":
          aValue = a.groupName.toLowerCase();
          bValue = b.groupName.toLowerCase();
          break;
        case "outlets":
          aValue = a.chains.length;
          bValue = b.chains.length;
          break;
        case "status":
          aValue = a.status;
          bValue = b.status;
          break;
        default:
          aValue = a.name.toLowerCase();
          bValue = b.name.toLowerCase();
      }

      if (sortOrder === "asc") {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });

    return filtered;
  }, [flatBrandData, searchTerm, filterStatus, filterGroup, sortBy, sortOrder]);

  // Get unique groups for filter dropdown
  const availableGroups = useMemo(() => {
    if (!table.data) return [];
    return table.data.map((group) => ({
      id: group._id,
      name: group.name,
    }));
  }, [table.data]);

  const valueChange = async (group, brand) => {
    let groupIndex = group.brands
      .map((brands, index) => ({ ...brands, index: index }))
      .find((brands) => brands.braKey === brand.braKey);

    const newStatus = group.brands[groupIndex.index].status === 1 ? 0 : 1;
    group.brands[groupIndex.index].status = newStatus;

    let dataToUpdate = {
      ...group,
    };

    try {
      await axios.put(
        props.chimeraserv.urlPost + "/group/update",
        dataToUpdate,
        {
          headers: {
            Authorization: props.user.data.usrKey,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      // Update the local state to reflect the change
      setTable((prev) => ({
        ...prev,
        data: prev.data.map((item) =>
          item._id === group._id
            ? {
                ...item,
                brands: item.brands.map((b) =>
                  b.braKey === brand.braKey ? { ...b, status: newStatus } : b
                ),
              }
            : item
        ),
      }));
    } catch (error) {
      console.error("Error updating brand status:", error);
      // Revert on error (optional)
      setTable((prev) => ({
        ...prev,
        data: prev.data.map((item) =>
          item._id === group._id
            ? {
                ...item,
                brands: item.brands.map((b) =>
                  b.braKey === brand.braKey ? { ...b, status: brand.status } : b
                ),
              }
            : item
        ),
      }));
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleStatusFilter = (e) => {
    setFilterStatus(e.target.value);
  };

  const handleGroupFilter = (e) => {
    setFilterGroup(e.target.value);
  };

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(field);
      setSortOrder("asc");
    }
  };

  const clearFilters = () => {
    setSearchTerm("");
    setFilterStatus("all");
    setFilterGroup("all");
    setSortBy("brand");
    setSortOrder("asc");
  };

  const getSortIcon = (field) => {
    if (sortBy !== field) return "sort";
    return sortOrder === "asc" ? "sort-up" : "sort-down";
  };

  const renderData = () =>
    filteredAndSortedData.map((brand, key) => (
      <tr key={`${brand.groupId}-${brand.braKey}`}>
        <td>
          <div className="group-info">
            <strong>{brand.groupName}</strong>
          </div>
        </td>
        <td>
          <div className="brand-info">
            <strong>{brand.name}</strong>
          </div>
        </td>
        <td>
          <span className="count-badge">{brand.chains.length}</span>
        </td>

        <td className="actions">
          {props.user.data.level === 0 ? (
            <div className="actions actionsAdmin">
              <label className="switch">
                <input
                  type="checkbox"
                  id={brand.braKey}
                  checked={!!brand.status}
                  onChange={() => valueChange(brand.group, brand)}
                />
                <span className="slider"></span>
              </label>
              <Link
                to={
                  location.pathname.split("/").splice(0, 4).join("/") +
                  "/edit/" +
                  brand.braKey
                }
                state={{ brandData: brand, groupData: brand.group }}
              >
                <FontAwesomeIcon className="icon" icon={["fas", "cog"]} /> Edit
              </Link>
            </div>
          ) : (
            <div />
          )}
          <Link
            to={
              location.pathname.split("/").splice(0, 4).join("/") +
              "/view/" +
              brand.braKey
            }
            state={{ brandData: brand, groupData: brand.group }}
          >
            <FontAwesomeIcon className="icon" icon={["fas", "eye"]} /> View
          </Link>
        </td>
      </tr>
    ));

  const Loader =
    props.components && props.components.setting && props.components.setting[1]
      ? props.components.setting[1].component
      : () => <div>Loading...</div>;

  return (
    <div className="custForm">
      <div className="viewTitle">List of Brands</div>

      {/* Search and Filter Controls */}
      <div className="table-controls">
        <div className="search-section">
          <div className="search-input-group">
            <FontAwesomeIcon className="search-icon" icon={["fas", "search"]} />
            <input
              type="text"
              className="form-control search-input"
              placeholder="Search by brand name, group name, or brand key..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
            {searchTerm && (
              <button
                type="button"
                className="clear-search"
                onClick={() => setSearchTerm("")}
                title="Clear search"
              >
                <FontAwesomeIcon icon={["fas", "times"]} />
              </button>
            )}
          </div>
        </div>

        <div className="filters-section">
          <select
            className="form-control filter-select"
            value={filterGroup}
            onChange={handleGroupFilter}
          >
            <option value="all">Groups</option>
            {availableGroups.map((group) => (
              <option key={group.id} value={group.id}>
                {group.name}
              </option>
            ))}
          </select>

          <select
            className="form-control filter-select"
            value={filterStatus}
            onChange={handleStatusFilter}
          >
            <option value="all"> Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>

          <button
            type="button"
            className="btn btn-secondary clear-filters"
            onClick={clearFilters}
            title="Clear all filters"
          >
            <FontAwesomeIcon icon={["fas", "refresh"]} /> Clear
          </button>
        </div>
      </div>

      {/* Results Summary */}
      {table.data && (
        <div className="results-summary">
          Showing {filteredAndSortedData.length} of {flatBrandData.length}{" "}
          brands
          {(searchTerm || filterStatus !== "all" || filterGroup !== "all") && (
            <span className="filtered-indicator">
              <FontAwesomeIcon icon={["fas", "filter"]} /> Filtered
            </span>
          )}
        </div>
      )}

      <div>
        {!table.data ? (
          <Loader />
        ) : (
          <div className="table-container">
            <table className="table table-striped defaultTable">
              <thead>
                <tr>
                  <th
                    scope="col"
                    onClick={() => handleSort("group")}
                    className="sortable"
                  >
                    Group
                    <FontAwesomeIcon
                      className="sort-icon"
                      icon={["fas", getSortIcon("group")]}
                    />
                  </th>
                  <th
                    scope="col"
                    onClick={() => handleSort("brand")}
                    className="sortable"
                  >
                    Brand
                    <FontAwesomeIcon
                      className="sort-icon"
                      icon={["fas", getSortIcon("brand")]}
                    />
                  </th>
                  <th
                    scope="col"
                    onClick={() => handleSort("outlets")}
                    className="sortable"
                  >
                    No. of Outlets
                    <FontAwesomeIcon
                      className="sort-icon"
                      icon={["fas", getSortIcon("outlets")]}
                    />
                  </th>

                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredAndSortedData.length > 0 ? (
                  renderData()
                ) : (
                  <tr>
                    <td
                      colSpan={table.head.length}
                      className="text-center no-results"
                    >
                      {searchTerm ||
                      filterStatus !== "all" ||
                      filterGroup !== "all" ? (
                        <div>
                          <FontAwesomeIcon
                            icon={["fas", "search"]}
                            className="no-results-icon"
                          />
                          <p>No brands found matching your search criteria</p>
                          <button
                            className="btn btn-link"
                            onClick={clearFilters}
                          >
                            Clear filters to see all brands
                          </button>
                        </div>
                      ) : (
                        <div>
                          <FontAwesomeIcon
                            icon={["fas", "tag"]}
                            className="no-results-icon"
                          />
                          <p>No brands available</p>
                        </div>
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default ListBrand;
